export const ZusTabs = Object.freeze({
  ACTIVE: {
    text: 'Active',
  },
  NOT_ACTIVE: {
    text: 'Not Active',
  },
  ALL: {
    text: 'All',
  },
});

export const DefaultTabInfo = Object.freeze({
  ACTIVE: {
    text: ZusTabs.ACTIVE.text,
    count: 0,
  },
  NOT_ACTIVE: {
    text: ZusTabs.NOT_ACTIVE.text,
    count: 0,
  },
  ALL: {
    text: ZusTabs.ALL.text,
    count: 0,
  },
});

export const TableHeaders = [
  { column: 'zusPatientId', label: 'ZUS Patient ID', width: '20%', sortBy: 'text' },
  { column: 'zusUpid', label: 'ZUS UPID', width: '20%', sortBy: 'text' },
  { column: 'status', label: 'Status', width: '10%', sortBy: 'text' },
  { column: 'historyJob', label: 'History Job', width: '18%', sortBy: 'text' },
  { column: 'lastSyncedAt', label: 'Last Synced', width: '14%', sortBy: 'value' },
  { column: 'actions', label: 'Actions', width: '18%' },
];
